import React from 'react';

const Header = () => {
  return (
    <section class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
            <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
            <img class="object-cover object-center rounded" alt="hero" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fskdesu.com%2Fwp-content%2Fuploads%2F2021%2F11%2Fkonnichiwa.jpg&f=1&nofb=1&ipt=12d75bbcdd809de0f3c6b9ea07dd2d6637391967bdbb0c143c4d3816444cb395"/>
            </div>
            <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">ようこそ (WELCOME)
                <br class="hidden lg:inline-block"/>ALL YOU NEED TO LEARN JAPANESE IS HERE
            </h1>
            <p class="mb-8 leading-relaxed">The words and phrases are displayed in cards to aid memorisation and quick reference</p>
            <div class="flex justify-center">
                {/* <button class="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">Button</button> */}
                {/* <button class="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">Button</button> */}
            </div>
            </div>
        </div>
    </section>
  );
};

export default Header;